import { ofType } from 'redux-observable';
import {
	switchMap,
	map,
	catchError,
} from 'rxjs/operators';
import { rxjsApiFetcher } from '../../../lib/general-utils';
import {
	actionTypes,
	platformSettingActions,
	notifyActions,
} from '../../../controller';
import {
	catchErrorForEpics,
} from '../../../../lib/epic-utils';

const {
	START_FETCH_PLATFORM_SETTING,
} = actionTypes;
const {
	notifyErrorAction,
} = notifyActions;
const {
	fetchPlatformSettingSuccessAction,
	fetchPlatformSettingFailedAction,
} = platformSettingActions;

export function fetchPlatformSettingEpic(action$) {
	return action$.pipe(
		ofType(START_FETCH_PLATFORM_SETTING),
		switchMap(() =>
			rxjsApiFetcher
				.get('platform-settings')
				.pipe(
					map(payload => payload.response),
					map(setting => fetchPlatformSettingSuccessAction(setting)),
					catchError(error => catchErrorForEpics(error, fetchPlatformSettingFailedAction, notifyErrorAction)),
				),
		),
	);
}
